export const BASE_URL = 'https://sds3-manoel.herokuapp.com'